(function($) {
    $('document').ready(function() {
        let policyAcceptanceForm = $('.policy-acceptance-form');
        if (policyAcceptanceForm.length === 0) {
            return; // Abandon this hook if target does not exist
        }

        let submitButton = $('button#guest-policy-submission');
        let policyCheckboxes = $('input.policy-checkbox');
        let policyInputs = $('input.policy-data');

        const validateInputs = function() {
            let emptyInput = false;
            policyInputs.each(function() {
                if ($(this).val().trim() === '') {
                    emptyInput = true;
                }
            });

            if (policyCheckboxes.length === $('input.policy-checkbox:checked').length && !emptyInput) {
                submitButton.removeClass('disabled');
            } else {
                submitButton.addClass('disabled');
            }
        }
        validateInputs();
        policyCheckboxes.change(validateInputs)
        policyInputs.keyup(validateInputs);
    });
})(jQuery);